import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.toggleFields());
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ["class"],
    });

    this.toggleFields();
  }

  disconnect() {
    this.observer.disconnect();
  }

  toggleFields() {
    this.element
      .querySelectorAll("input, select, textarea")
      .forEach((input) => {
        if (this.element.classList.contains("hidden")) {
          if (!["true", "false"].includes(input.dataset.wasRequired)) {
            input.dataset.wasRequired = input.required ? "true" : "false";
          }

          input.removeAttribute("required");
          input.setAttribute("disabled", "true");
        } else {
          if (input.dataset.wasRequired === "true") {
            input.setAttribute("required", "true");
          }

          input.removeAttribute("disabled");
        }
      });
  }
}
